import React, { useRef, useState } from "react";
import { Grid } from "@mui/material";

import { FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { LARGO, mensajeLargo } from "consts/limites-campos";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHZonaUpd } from "services/services-mia/programa-salud/estructuras/RNHZonaUpd";

export default function UpdateModal({ updateList, row, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const formikRef = useRef();
    const [inRequest, setInRequest] = useState(false);
    const handleSubmit = async (values) => {
        const response = await RNHZonaUpd(credentials, {
            id: row.id,
            name: values.nombre,
            cod: values.cod,
            wkt: values.wkt,
            version: row.version,
        })
        if (response.ok) {
            setSnackBarInfo({
                message: "Zona modificada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    };
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: row.name ?? "",
                cod: row.cod ?? "",
                wkt: row.wkt ?? ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(LARGO.nombre, mensajeLargo(LARGO.nombre)).required("Debe ingresar un nombre"),
                    cod: yup.string("Debe ingresar un código").max(LARGO.cod, mensajeLargo(LARGO.cod)).required("Debe ingresar un código"),
                })
            }
            onSubmit={(values) => {
                handleSubmit(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <Grid
                      container
                      rowSpacing={0}
                      columnSpacing={2}
                      sx={{
                        width: "100%",
                        "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
                      }}
                    >
                      <Grid item xs={4}>
                        <FormikTextInput
                            fullWidth={true}
                            name="cod"
                            labelText="Código"
                            inputProps={{ maxLength: LARGO.cod }}
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <FormikTextInput
                            fullWidth={true}
                            name="nombre"
                            labelText="Nombre"
                            inputProps={{ maxLength: LARGO.nombre }}
                        />
                      </Grid>
                    </Grid>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Modificar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
